import { Box, makeStyles } from '@material-ui/core';
import { getTimeSimplifiedDurationFn, useCadencedTime } from '@timeflies/app-ui';
import React from 'react';
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: function (_a) {
            var spellCategory = _a.spellCategory;
            return ({
                backgroundColor: palette.spellCategories[spellCategory],
                height: '100%'
            });
        }
    });
});
export var SpellDurationGauge = function (_a) {
    var spellCategory = _a.spellCategory, startTime = _a.startTime, duration = _a.duration;
    var classes = useStyles({ spellCategory: spellCategory });
    var timeSimplifiedDurationFn = React.useMemo(function () { return getTimeSimplifiedDurationFn({ startTime: startTime, duration: duration }, 2); }, [startTime, duration]);
    var remainingTime = useCadencedTime(timeSimplifiedDurationFn);
    var width = remainingTime / duration * 100 + "%";
    var opacity = remainingTime < duration && remainingTime > 0
        ? 1
        : 0.25;
    return React.createElement(Box, { className: classes.root, style: {
            width: width,
            opacity: opacity
        } });
};
